import React from 'react'
import { Checkbox } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import isEmpty from 'lodash/isEmpty'
import {
  STATUS_TYPE_BASE,
  STATUS_TYPE_IN_PROGRESS,
  STATUS_TYPE_COMPLETE,
} from 'routes/App/Apps/DailyLogbookEvents/Questionnaire/StatusIcon'

function BulkUnitsSelect({
  multiChoice,
  unitsIds,
  unitGroupsIds,
  input_items,
  needs_locus,
  needs_locus_group,
  evt_tasks,
  handleUnitsChange,
  handleGroupUnitsChange,
  data: { name, locuses, id: currentId },
}) {
  const isInputValueExist = (inputList, allExist = false) => {
    if (Array.isArray(inputList)) {
      if (!allExist) {
        return inputList.some(({ result }) => result || result === false)
      }

      if (needs_locus_group && needs_locus) {
        return (
          inputList.every(({ result }) => result || result === false) &&
          locuses.every(locusData =>
            evt_tasks.some(
              ({ evt_inputs, locus: locusItem }) =>
                locusItem === locusData.id &&
                evt_inputs.length === inputList.length &&
                evt_inputs.every(({ result }) => result || result === false),
            ),
          )
        )
      }

      return inputList.every(({ result }) => result || result === false)
    }
  }

  const handleGroupClick = groupId => {
    const unitIdList = []
    const unitNameList = []

    locuses.forEach(({ id, name }) => {
      unitIdList.push(id)
      unitNameList.push(name)
    })

    handleGroupUnitsChange(groupId, unitIdList, unitNameList)
  }

  const getFieldStatus = (field, id) => {
    const checkedField = field === 'locusGroup' ? 'locus_group' : 'locus'
    const checkEvtTasks = evt_tasks && evt_tasks.length > 0
    const inputsLength = input_items.filter(
      ({ input_item_type }) => input_item_type === 'input',
    ).length
    const inputsInGroupsLength = input_items
      .filter(({ input_item_type, duplicate_context }) =>
        input_item_type === 'input_group' && !isEmpty(duplicate_context)
          ? duplicate_context[checkedField] === id
          : true,
      )
      .reduce(
        (prevVal, { inputs }) => prevVal + (inputs ? inputs.length : 0),
        0,
      )
    const allFilled =
      checkEvtTasks &&
      evt_tasks.some(
        item =>
          item[checkedField] === id &&
          inputsLength + inputsInGroupsLength === item.evt_inputs.length &&
          item.evt_inputs.every(
            locusInput =>
              locusInput.result ||
              locusInput.result === false ||
              locusInput.result === 0,
          ),
      )
    const someFilled =
      checkEvtTasks &&
      evt_tasks.some(
        item => item[checkedField] === id && isInputValueExist(item.evt_inputs),
      )

    if (allFilled) {
      return STATUS_TYPE_COMPLETE
    }

    if (someFilled) {
      return STATUS_TYPE_IN_PROGRESS
    }

    return STATUS_TYPE_BASE
  }

  const findSelectedUnit = (units, unitId) =>
    !isEmpty(units) && units.some(id => Number(id) === unitId)

  const isSelected = (groupId, unitId) => {
    if (groupId && !unitId) {
      return findSelectedUnit(unitGroupsIds, groupId)
    }

    if (unitId) {
      const groupUnits = unitsIds ? Object.values(unitsIds).flat(1) : []

      return findSelectedUnit(groupUnits, unitId)
    }
  }

  const allUnitsSelected = () => {
    const selectedUnits = unitsIds ? Object.values(unitsIds).flat(1) : []

    return locuses.every(({ id: locusId }) =>
      selectedUnits.find(selectedUnitId => locusId === selectedUnitId),
    )
  }

  const renderGroupUnits = () => (
    <div className="task-group-unit-box">
      <div
        className="task-unit-group-title"
        onClick={() => handleGroupClick(currentId)}>
        {multiChoice && (
          <Checkbox
            href={null}
            className="task-unit-group-checkbox"
            color="primary"
            checked={allUnitsSelected()}
          />
        )}
        <div role="presentation">{name}</div>
      </div>
      <div className="task-unit-box">
        {locuses.map(({ id, name }) => {
          const fieldStatus = getFieldStatus('locus', id)

          return (
            <div key={id} className="task-checkbox-wrapper">
              <div
                role="presentation"
                className={`task-single-unit ${fieldStatus}`}
                onClick={() => handleUnitsChange(currentId, id)}>
                {name}
              </div>
              {multiChoice && (
                <Checkbox
                  href={null}
                  className="task-unit-checkbox"
                  color="primary"
                  checked={isSelected(null, id)}
                />
              )}
            </div>
          )
        })}
      </div>
    </div>
  )

  const renderGroupOrLocusUnits = unitGroupMode => {
    const groupOrLocusUnits = unitGroupMode ? 'locusGroup' : 'locus'
    const fieldStatus = getFieldStatus(groupOrLocusUnits, currentId)
    const currentHandler = () =>
      unitGroupMode
        ? handleUnitsChange(currentId, '')
        : handleUnitsChange('', currentId)

    return (
      <div className="task-checkbox-wrapper">
        <div className="task-group-unit-box">
          <div className="task-unit-box">
            <div
              role="presentation"
              className={`task-single-unit ${fieldStatus}`}
              onClick={currentHandler}>
              {name}
            </div>
            {multiChoice && (
              <Checkbox
                href={null}
                className="task-unit-checkbox"
                color="primary"
                checked={
                  unitGroupMode
                    ? isSelected(currentId)
                    : isSelected(null, currentId)
                }
              />
            )}
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      {needs_locus_group && needs_locus && renderGroupUnits()}
      {needs_locus_group && !needs_locus && renderGroupOrLocusUnits(true)}
      {!needs_locus_group && needs_locus && renderGroupOrLocusUnits()}
    </>
  )
}

export default injectIntl(BulkUnitsSelect)
